import humanDate from 'shared/utils/humanDate'
import humanTime from 'shared/utils/humanTime'

export default function humanDateTime(timestamp) {
	return `${humanDate(timestamp)}, ${humanTime(timestamp)}`
}
